/**
 * Audience constants
 * Centralized location for audience-related string constants used across the audience feature
 */

// Route/State names
export const AUDIENCE_STATES = {
    BUILDER: 'audience-builder',
    EXPLORER: 'audience-explorer',
  };
  
  // User types
  export const USER_TYPES = {
    DEBUG: 'debug',
    ADMIN: 'admin',
    REGULAR: 'regular',
  };
  
  // Individual channel identifiers
  export const CHANNEL_IDS = {
      LINKEDIN: 'linkedin',
      ARTICLES: 'articles',
      AU_TELCO: 'au_telco',
      TIVO: 'tivo',
      SMART_TV_INSCAPE: 'smart_tv_inscape',
      HISENSE: 'hisense',
      SNBB: 'snbb',
      DATA_SPARK: 'data_spark',
      SG_BIDSTREAM: 'sg_bidstream',
      BIDSTREAM: 'bidstream',
      PEERLOGIX: 'peerlogix',
  };
  
  // Channel groups
  export const SG_CHANNELS = [
    CHANNEL_IDS.SNBB,
    CHANNEL_IDS.DATA_SPARK,
    CHANNEL_IDS.SG_BIDSTREAM,
    CHANNEL_IDS.BIDSTREAM,
  ];
  
  export const TV_CHANNELS = [
    CHANNEL_IDS.SMART_TV_INSCAPE,
    CHANNEL_IDS.TIVO,
    CHANNEL_IDS.HISENSE,
  ];
  
  // Channels that don't support TV tab
  export const NON_TV_TAB_CHANNELS = [
    ...SG_CHANNELS,
    CHANNEL_IDS.AU_TELCO,
    CHANNEL_IDS.ARTICLES,
  ];

  // Channels excluded from searches feature
export const EXCLUDED_SEARCH_CHANNELS = [
  ...TV_CHANNELS,
  CHANNEL_IDS.PEERLOGIX,
  CHANNEL_IDS.SG_BIDSTREAM,
  CHANNEL_IDS.BIDSTREAM,
];